'use client'

import { useReplacementsContext } from '@/context/ReplacementsContext'
import Replacements from '@/scenes/Product/Replacements'
import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import { useIsMobile } from '@mercadoni/sinister/dist/cjs/shared/hooks'

const ReplacementsModal = () => {
  const [isMobile] = useIsMobile()
  const { setOpenModal, openModal, selectedProduct, setSelectedProduct } =
    useReplacementsContext()
  const copies = getLocale() || defaultLocale

  return (
    <>
      {openModal && selectedProduct && (
        <Replacements
          product={selectedProduct}
          onCancel={() => {
            setOpenModal(false)
            setSelectedProduct(null)
          }}
          copies={copies}
          isMobile={isMobile}
        />
      )}
    </>
  )
}

export default ReplacementsModal
